module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_User_16"],"path":[{"$":{"d":"M14,11.18V15H2V11.18C2,9.46,4.68,8,8,8S14,9.46,14,11.18ZM8,1a3,3,0,1,0,3,3A3,3,0,0,0,8,1Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_User_16.svg
// module id = F8W4
// module chunks = 1